import { InjectionToken } from "@angular/core";

export const LibConfigService = new InjectionToken<LibConfig>('LibConfig');

export interface LibConfig {
    production: boolean;
    pushCheckTime: number;
  }